import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { DynamicFormsModule } from "../../dynamic-forms/dynamic-forms.module";
import { ButtonModule } from "../button/button.module";
import { IconModule } from "../icon/icon.module";
import { ChartPageViewerComponent } from "./chart-page-viewer/chart-page-viewer.component";

@NgModule({
  imports: [
    CommonModule,
    ScrollingModule,
    ButtonModule,
    FormsModule,
    DynamicFormsModule,
    IconModule,
  ],
  declarations: [
    ChartPageViewerComponent,
  ],
  exports: [
    ChartPageViewerComponent,
  ],
})
export class ChartModule { }
